import { useNavigation } from '../../providers/NavigationProvider';
import MeetingRoster from '../MeetingRoster';

import Navigation from '.';

const NavigationControl = () => {
    const { showNavbar, showRoster } = useNavigation();

    return (
        <>
            {showNavbar ? <Navigation /> : null}
            {showRoster ? <MeetingRoster /> : null}
        </>
    );
};

export default NavigationControl;
